import { useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [step, setStep] = useState(1);

  const request = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/auth/reset-request", { email });
      toast.success(t("fp.email_sent"));
      if (data.reset_token_debug) {
        setToken(data.reset_token_debug);
        toast.info(t("fp.debug_prefill"));
      }
      setStep(2);
    } catch (err) { toast.error(t("fp.err")); }
  };

  const confirm = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-confirm", { token, new_password: newPassword });
      toast.success(t("fp.reset_success"));
      setStep(3);
    } catch (err) {
      toast.error(err.response?.data?.detail || t("fp.err"));
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center p-8" data-testid="forgot-page">
      <div className="w-full max-w-md bg-white p-8 rounded-lg border border-[#1A3322]/10">
        {step === 1 && (
          <form onSubmit={request} className="space-y-5" data-testid="forgot-request-form">
            <h1 className="heading font-extrabold text-3xl">{t("fp.title")}</h1>
            <p className="text-sm text-[#4B5563]">{t("fp.desc")}</p>
            <div className="space-y-2">
              <Label>{t("fp.email")}</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email"/>
            </div>
            <Button type="submit" className="w-full pill-btn bg-[#1A3322] hover:bg-[#24472F] rounded-full h-11" data-testid="forgot-submit">{t("fp.send")}</Button>
          </form>
        )}
        {step === 2 && (
          <form onSubmit={confirm} className="space-y-5" data-testid="forgot-confirm-form">
            <h1 className="heading font-extrabold text-3xl">{t("fp.new_title")}</h1>
            <div className="space-y-2">
              <Label>{t("fp.token")}</Label>
              <Input required value={token} onChange={(e) => setToken(e.target.value)} data-testid="forgot-token"/>
            </div>
            <div className="space-y-2">
              <Label>{t("fp.new_pw")}</Label>
              <Input type="password" minLength={6} required value={newPassword} onChange={(e) => setNewPassword(e.target.value)} data-testid="forgot-new-password"/>
            </div>
            <Button type="submit" className="w-full pill-btn bg-[#1A3322] hover:bg-[#24472F] rounded-full h-11" data-testid="forgot-confirm">{t("fp.reset")}</Button>
          </form>
        )}
        {step === 3 && (
          <div className="text-center space-y-4">
            <h1 className="heading font-extrabold text-2xl">{t("fp.pw_changed")}</h1>
            <a href="/connexion" className="text-[#1A3322] font-semibold underline">{t("fp.login_link")}</a>
          </div>
        )}
      </div>
    </div>
  );
}
